import axios from "axios"
import { partnamePut } from "./partnameSlice";


export function partnamePutAxios(partData) {
        return async function partnamePutThunk(dispatch, getState) {
            const response = await axios.put(`/api/reservation/partname`, partData)
            dispatch(partnamePut(response.data))
        };
    }